import React from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import {
  handleGoogleLogin,
  openEmailLoginDialog,
  openEmailSignUpDialog,
  openResetPasswordDialog,
  handleEmailPasswordLogin,
} from "../auth/AuthActions";

const LoginChoiceDialog = ({
  loginWithGoogle,
  setShowLoginChoiceDialog,
  setShowSignUpDialog,
  setShowLoginDialog,
  setShowResetPasswordDialog,
}) => {
  return (
    <div className="space-y-6 py-2">
      <p className="text-sm text-gray-600 text-center">
        Choose a sign-in method to continue to your AIRCHECK account.
      </p>
      <div className="grid grid-cols-2 gap-4">
        <button
          type="button"
          onClick={() => handleGoogleLogin(loginWithGoogle, setShowLoginChoiceDialog)}
          className="flex flex-col items-center justify-center gap-3 p-6 border border-gray-200 rounded-lg hover:border-blue-500 hover:shadow-md transition-all duration-200"
        >
          <img className="w-12 h-12" src="images/icons/google.png" alt="Google" />
          <span className="text-sm font-medium text-gray-800">Continue with Google</span>
        </button>
        <button
          type="button"
          onClick={() =>
            openEmailLoginDialog(
              setShowLoginChoiceDialog,
              setShowSignUpDialog,
              setShowLoginDialog,
              setShowResetPasswordDialog,
            )
          }
          className="flex flex-col items-center justify-center gap-3 p-6 border border-gray-200 rounded-lg hover:border-blue-500 hover:shadow-md transition-all duration-200"
        >
          <img className="w-12 h-12" src="images/icons/email.png" alt="Email" />
          <span className="text-sm font-medium text-gray-800">Continue with Email</span>
        </button>
      </div>
      <p className="text-xs text-gray-500 text-center">
        Don&apos;t have an account?{" "}
        <button
          type="button"
          onClick={() =>
            openEmailSignUpDialog(setShowLoginDialog, setShowSignUpDialog)
          }
          className="text-blue-700 hover:text-blue-500 font-medium"
        >
          Create one
        </button>
      </p>
    </div>
  );
};

const LoginDialog = ({ email, setEmail, password, setPassword, onSubmit }) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && onSubmit) {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <div className="space-y-4 py-2">
      <p className="text-sm text-gray-600">
        Welcome back. Sign in with your email and password to continue.
      </p>
      <div className="flex flex-col gap-1">
        <label htmlFor="email" className="text-sm font-medium text-gray-700">
          Email address
        </label>
        <InputText
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="you@example.com"
          className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="flex flex-col gap-1">
        <label htmlFor="password" className="text-sm font-medium text-gray-700">
          Password
        </label>
        <InputText
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="••••••••"
          className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
    </div>
  );
};

const LoginDialogFooter = ({
  email,
  password,
  loginWithEmailPassword,
  setNotificationMessage,
  setIsError,
  setShowNotification,
  setShowResetPasswordDialog,
  setShowLoginDialog,
  setShowSignUpDialog,
}) => {
  const submit = () =>
    handleEmailPasswordLogin(
      email,
      password,
      loginWithEmailPassword,
      setNotificationMessage,
      setIsError,
      setShowNotification,
      setShowLoginDialog,
    );

  return (
    <div className="flex flex-col gap-3 pt-2">
      <div className="flex justify-end">
        <Button
          label="Sign In"
          onClick={submit}
          className="rounded-md shadow-sm px-5 py-2 bg-green-500 text-white hover:bg-green-700 transition duration-200"
        />
      </div>
      <div className="flex items-center justify-between text-xs">
        <button
          type="button"
          onClick={() =>
            openResetPasswordDialog(
              setShowResetPasswordDialog,
              setShowSignUpDialog,
              setShowLoginDialog,
            )
          }
          className="text-blue-700 hover:text-blue-500 font-medium transition duration-200"
        >
          Forgot password?
        </button>
        <button
          type="button"
          onClick={() =>
            openEmailSignUpDialog(setShowLoginDialog, setShowSignUpDialog)
          }
          className="text-blue-700 hover:text-blue-500 font-medium transition duration-200"
        >
          Need an account? Sign up
        </button>
      </div>
    </div>
  );
};

export { LoginChoiceDialog, LoginDialog, LoginDialogFooter };
